import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/lib/theme';

export const ThemeToggle = ({ className = '', variant = 'ground' }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const base = variant === 'chrome'
    ? 'text-onchrome/70 hover:text-onchrome hover:bg-onchrome/10'
    : 'text-ink/60 hover:text-ink hover:bg-ink/5';
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Açık temaya geç' : 'Koyu temaya geç'}
      title={isDark ? 'Açık tema' : 'Koyu tema'}
      className={`p-2 rounded-md transition-colors active:scale-90 ${base} ${className}`}
    >
      {isDark
        ? <Sun strokeWidth={1.5} className="w-5 h-5" />
        : <Moon strokeWidth={1.5} className="w-5 h-5" />}
    </button>
  );
};

export default ThemeToggle;
